import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials: true so the browser sends the HttpOnly `shv_session` cookie
// on every request. The JWT is no longer stored in localStorage — it never
// touches JavaScript, eliminating the XSS-token-theft surface.
export const api = axios.create({ baseURL: API, withCredentials: true });

// One-time migration: wipe any legacy token left in localStorage from older
// browser sessions. The cookie is now the only source of truth.
try {
  if (typeof window !== "undefined" && window.localStorage) {
    window.localStorage.removeItem("shv_token");
  }
} catch (_e) { /* ignore — private mode etc. */ }

// The user profile is stored in localStorage purely for UX (avoid flash of
// unauthenticated UI on reload). It is NOT a credential — every API call is
// still authorized server-side via the HttpOnly cookie.
const USER_KEY = "shv_user";

export const saveAuth = (_token, user) => {
  try { localStorage.setItem(USER_KEY, JSON.stringify(user)); } catch (_e) { /* ignore */ }
};
export const clearAuth = () => {
  try { localStorage.removeItem(USER_KEY); } catch (_e) { /* ignore */ }
};
export const getUser = () => {
  try {
    const u = localStorage.getItem(USER_KEY);
    return u ? JSON.parse(u) : null;
  } catch (_e) { return null; }
};

/**
 * Open a Document Vault file in a new tab using a short-lived signed URL.
 * The session cookie is never exposed in the URL — we exchange the cookie for
 * a purpose-scoped doc-view token via the API first.
 */
export const openDocument = async (docId) => {
  try {
    const { data } = await api.post(`/documents/${docId}/sign`);
    const url = `${API}/documents/${docId}/file?token=${encodeURIComponent(data.token)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  } catch (e) {
    const msg = e?.response?.data?.detail || "Unable to open document";
    throw new Error(msg);
  }
};
